import type React from "react";
import { Box, Typography } from "@mui/material";
import OrderStatusChip from "./OrderStatusChip";
import { getHistoryStatusChange, type DisplayHistoryChange } from "../../utils/entityChangeHistory";

interface HistoryEntryStatusSummaryProps {
  changes: DisplayHistoryChange[];
  "data-testid"?: string;
}

const HistoryEntryStatusSummary: React.FC<HistoryEntryStatusSummaryProps> = ({
  changes,
  "data-testid": testId,
}) => {
  const statusChange = getHistoryStatusChange(changes);
  if (!statusChange) {
    return null;
  }

  const { before, after } = statusChange;

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}
      data-testid={testId}
    >
      {before && <OrderStatusChip status={before} />}
      {before && after && (
        <Typography variant="body2" color="text.secondary" aria-hidden="true">
          →
        </Typography>
      )}
      {after && <OrderStatusChip status={after} />}
    </Box>
  );
};

export default HistoryEntryStatusSummary;
